export default __webpack_public_path__ + "static/media/kitchen5-beforeC-768w.c636fc74.webp";